/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:48:30
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-05-27 15:52:36
 * @FilePath: \monitor\src\language\user\register.js
 * @Description: 
 */
const info = {
  CN: {
    registerTitle: "注册账号",
    forgetTitle: "重置密码",
    emailpla: "请输入邮箱",
    emailplaErr: "请输入正确的邮箱",
    verifyPla: "请输入验证码",
    passwordPla: "请输入密码",
    newPasswordPla: "请输入新密码",
    confirmPasswordPla: "请输入确认密码",
    goLoginBtn: "登录界面",
    registerBtn: "注册",
    forgetBtn: "重置",
    forgetpwd: "忘记密码",
    errorTitle: "注册失败",
    verifyLenPla: "验证码不少于4位",
    passwordLenPla: "密码长度在 6 到 16 个字符",
    passwordCompositionPla: "密码需要由数字和字母组成",
    twoPasswordPla: "两次输入密码不一致!",
    successText: "注册成功",
    warningText: "请稍后再试！",
    verifyErrorText: "验证码错误，请重新输入！",
    emailErrorText: "该邮箱已经注册过了！",
    verifySuccessText: "发送成功，请查访问邮箱收取验证码！",
    registerInformation: "获取账号信息，请联系相关项目管理员！新项目配置，请联系技术支持。",
  },
  EN: {
    registerTitle: "Register account",
    forgetTitle: "reset password",
    emailpla: "Please input email",
    emailplaErr: "Please enter the correct email address",
    verifyPla: "Please input verify code",
    passwordPla: "Please input password",
    newPasswordPla: "Please input new password",
    confirmPasswordPla: "Please input confirmation password",
    goLoginBtn: "To Login",
    registerBtn: "Register",
    forgetBtn: "reset",
    forgetpwd: "Forgot password",
    errorTitle: "Register failed",
    verifyLenPla: "verify code not less than 4 bytes",
    passwordLenPla: "Password length is between 6 and 16 characters",
    passwordCompositionPla: "Password should have both char and number",
    twoPasswordPla: "The passwords entered twice do not match!",
    successText: "Created successfully",
    warningText: "Please try again later!",
    verifyErrorText: "Verification code error, please re-enter!",
    emailErrorText: "This email has already been registered!",
    verifySuccessText: "Successfully sent, please check your email to receive a verification code!",
    registerInformation: "To obtain account information, please contact the relevant project administrator!",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/user/register.js